module.exports = __webpack_public_path__ + "static/media/Dropdown.b5cddd10.png";